export enum LimitType {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
}
